import axios from 'axios';

const baseURL = `${window.location.protocol}//${window.location.hostname}${import.meta.env.VITE_API_URL}/`;

const AxiosOICStat = axios.create({
  baseURL: baseURL,
});

// Set the default Authorization header for internal and cif modes
if (import.meta.env.VITE_PROJECT_TYPE === 'internal' || import.meta.env.VITE_PROJECT_TYPE === 'cif') {
  const token = localStorage.getItem("token");
  if (token) {
    AxiosOICStat.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
}

export default AxiosOICStat;
